import React from 'react';
import './HowToBuyContent.css';

// Данные о шагах процесса покупки
const purchaseSteps = [
  {
    number: 1,
    title: 'Авторизация в аккаунте',
    description: `Для оформления покупки нужен доступ к вашему игровому аккаунту. Вы отправляете логин и пароль (чаще всего логином является почта Google или Facebook). Иногда система может запросить код подтверждения.

Авторизация в вашем игровом аккаунте нужна для того, чтобы покупка начислилась именно на ваш аккаунт.

Все ваши данные полностью защищены. Мы удаляем их сразу после сделки. Также мы всегда рекомендуем сменить пароль после завершения диалога с администратором.`
  },
  {
    number: 2,
    title: 'Подтверждение аккаунта',
    description: 'После входа в аккаунт мы отправляем вам скриншот, чтобы вы убедились, что это именно ваш аккаунт, и подтвердили, куда оформлять покупку.'
  },
  {
    number: 3,
    title: 'Расчет и оплата',
    description: 'После подтверждения аккаунта мы считаем итоговую стоимость нужной покупки в рублях и отправляем вам платёжную ссылку для оплаты по карте банка или через СБП.'
  },
  {
    number: 4,
    title: 'Покупка',
    description: 'После успешной оплаты, мы приступаем к покупке вашего товара, используя наши иностранные карты. В среднем весь процесс занимает около 20 минут.'
  },
  {
    number: 5,
    title: 'Отчёт',
    description: `После завершения покупки администратор сообщит вам и предложит проверить наличие товара в вашей игре или приложении.

Сделка будет закрыта только после вашего подтверждения.`
  }
];

const HowToBuyContent = ({ videoSrc = '/video_how_to_buy.mp4' }) => {
  return (
    <div className="how-to-buy-content">
      {/* Левая колонка - Видеоинструкция */}
      <div className="how-to-buy-content__video-section">
        {/* Заголовок видеоинструкции */}
        {/* <div className="how-to-buy-content__video-header">
          <div className="how-to-buy-content__video-title">
            <VideoIcon />
            <span>Видеоинструкция</span>
          </div>
        </div> */}

        {/* Видеоплеер */}
        <div className="how-to-buy-content__video-player">
          <video 
            className="how-to-buy-content__video"
            src={videoSrc}
            controls
            controlsList="nodownload"
            playsInline
            preload="metadata"
          />
        </div>
      </div>

      {/* Правая колонка - Информация */}
      <div>
        {/* Заголовок */}
        <div className="how-to-buy-content__info-header">
          <h2 className="how-to-buy-content__title">Как происходит процесс покупки?</h2>
        </div>

        {/* Шаги */}
        <div className="how-to-buy-content__steps">
          {purchaseSteps.map((step, index) => (
            <div key={step.number} className="how-to-buy-content__step">
              <div className="how-to-buy-content__step-number">
                <span>{step.number}</span>
              </div>
              <div className="how-to-buy-content__step-content">
                <h3 className="how-to-buy-content__step-title">
                  {step.title}
                </h3>
                <p className="how-to-buy-content__step-description">{step.description}</p>
              </div>
              {index < purchaseSteps.length - 1 && (
                <div className="how-to-buy-content__step-divider" />
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default HowToBuyContent;

